// DATA SELECT
export const sportData = ['Trap', 'Skeet', 'Sporting', 'Double trap'];

export const brandData = [
  'Blaser F3',
  'Browning 525: XT, GTI, 325, 425',
  'Browning 725',
  'Caesar Guerini Summit',
  'P. Beretta ASE 90',
  'P. Beretta DT11: DT10',
  'P. Beretta 694: 680, 682, 686, 687, 688, 690, 692',
  'Perazzi MX8, MX2000, HT',
  'Kriegoff K80',
  'Rizzini BR 440, BR 460 (Removable Trigger)',
  'Rizzini Vertex, BR110 (No Removable Trigger)',
  'A. Zoli Kronos: Z Gun',
  'Beretta A400',
];

export const gripTypeData = ['grip_type_left', 'grip_type_right'];
export const gripSizeData = [
  'grip_size_xs',
  'grip_size_s',
  'grip_size_m',
  'grip_size_l',
  'grip_size_xl',
  'grip_size_none',
  'grip_size_universal',
  'grip_size_custom',
  'grip_size_s_m_l',
  'grip_size_I',
  'grip_size_II',
];
export const fixedGripSize = [
  'grip_size_none',
  'grip_size_universal',
  'grip_size_custom',
];

export const pipeSizeData = [
  'SUPER SHORT - 120 mm - Lenght range from 33,3 to 35,3 cm',
  'SHORT - 140 mm - Lenght range from 34,8 to 37,2 cm',
  'MEDIUM - 160 mm - Lenght range from 36,7 to 39,2 cm',
  'LONG - 180 mm - Lenght range from 38,7 to 41,2 cm',
];

export const handlesData = [
  'BLANK', // Inzoccato STD
  'BLANK SS', // Inzoccato Supersport - solo Perazzi e Beretta DT11
  'STD HANDLE - GLOVE', // STD impugnature con fermadito
  'C-HANDLE - NO GLOVE', // STD impugnature senza fermadito - solo per Beretta DT11 e 694
  'SPD HANDLE - HALF GLOVE', // Impugnatura mezzo fermadito
  'ANATOMIC GRIP', // Impugnatura anatomica
  'LAMINATE HANDLE BLACK', // STD HANDLE LAMINATO BLACK - SOLO X BERETTA DT 11 PERAZZI HT
  'LAMINATE HANDLE BLUE', // STD HANDLE LAMINATO BLUE - SOLO X BERETTA DT 11 PERAZZI HT
  'LAMINATE HANDLE HAVANA', // STD HANDLE LAMINATO HAVANA - SOLO X BERETTA DT 11 PERAZZI HT
  'LAMINATE HANDLE ORANGE', // STD HANDLE LAMINATO ORANGE - SOLO X BERETTA DT 11 PERAZZI HT
  'LAMINATE HANDLE RED', // STD HANDLE LAMINATO RED - SOLO X BERETTA DT 11 PERAZZI HT
  'A400 HANDLE', // Impugnatura A400
];

// ============================
// DATA CONFIGURATIONS
// ============================

// Hanldes by model
export const brandsByModel: Record<string, string[]> = {
  std: [
    brandData[0],
    brandData[1],
    brandData[2],
    brandData[3],
    brandData[4],
    brandData[5],
    brandData[6],
    brandData[7],
    brandData[8],
    brandData[9],
    brandData[10],
    brandData[11],
    brandData[12],
  ],
  junior: [
    brandData[0],
    brandData[1],
    brandData[2],
    brandData[3],
    brandData[4],
    brandData[5],
    brandData[6],
    brandData[7],
    brandData[8],
    brandData[9],
    brandData[10],
    brandData[11],
    brandData[12],
  ],
  rinascimento: [
    brandData[0],
    brandData[1],
    brandData[2],
    brandData[3],
    brandData[4],
    brandData[5],
    brandData[6],
    brandData[7],
    brandData[8],
    brandData[9],
    brandData[10],
    brandData[11],
    brandData[12],
  ],
  rr: [
    brandData[0],
    brandData[1],
    brandData[2],
    brandData[3],
    brandData[4],
    brandData[5],
    brandData[6],
    brandData[7],
    brandData[8],
    brandData[9],
    brandData[10],
    brandData[11],
    brandData[12],
  ],
  'rr-junior': [
    brandData[0],
    brandData[1],
    brandData[2],
    brandData[3],
    brandData[4],
    brandData[5],
    brandData[6],
    brandData[7],
    brandData[8],
    brandData[9],
    brandData[10],
    brandData[11],
    brandData[12],
  ],
  'rr-rinascimento': [
    brandData[0],
    brandData[1],
    brandData[2],
    brandData[3],
    brandData[4],
    brandData[5],
    brandData[6],
    brandData[7],
    brandData[8],
    brandData[9],
    brandData[10],
    brandData[11],
    brandData[12],
  ],
  superleggero: [
    brandData[0],
    brandData[1],
    brandData[2],
    brandData[3],
    brandData[4],
    brandData[5],
    brandData[6],
    brandData[7],
    brandData[8],
    brandData[9],
    brandData[10],
    brandData[11],
    brandData[12],
  ],
  spd: [
    brandData[0],
    brandData[1],
    brandData[2],
    brandData[3],
    brandData[4],
    brandData[5],
    brandData[6],
    brandData[7],
    brandData[8],
    brandData[9],
    brandData[10],
    brandData[11],
    brandData[12],
  ],
  supersport: [
    brandData[0],
    brandData[1],
    brandData[2],
    brandData[3],
    brandData[4],
    brandData[5],
    brandData[6],
    brandData[7],
    brandData[8],
    brandData[9],
    brandData[10],
    brandData[11],
  ],
  'c-model': [brandData[5], brandData[6]],
};

// Handles by sport
export const handlesByBrand: Record<string, string[]> = {
  'Blaser F3': [handlesData[0], handlesData[2]], //handlesData[4]], // handlesData[5]],
  'Browning 525: XT, GTI, 325, 425': [
    handlesData[0],
    handlesData[2],
    handlesData[4],
    //handlesData[5],
  ],
  'Browning 725': [
    handlesData[0],
    handlesData[2],
    //handlesData[4],
    //handlesData[5],
  ],
  'Caesar Guerini Summit': [
    handlesData[0],
    handlesData[2],
    //handlesData[4],
    // handlesData[5],
  ],
  'P. Beretta ASE 90': [
    handlesData[0],
    handlesData[2],
    //handlesData[4],
    // handlesData[5],
  ],
  'P. Beretta DT11: DT10': [
    handlesData[0],
    handlesData[1],
    handlesData[2],
    handlesData[3],
    handlesData[4],
    // handlesData[5],
    // handlesData[6],
    // handlesData[7],
    // handlesData[8],
    // handlesData[9],
    // handlesData[10],
  ],
  'P. Beretta 694: 680, 682, 686, 687, 688, 690, 692': [
    handlesData[0],
    handlesData[2],
    handlesData[3],
    handlesData[4],
    // handlesData[5],
  ],
  'Perazzi MX8, MX2000, HT': [
    handlesData[0],
    handlesData[1],
    handlesData[2],
    handlesData[4],
    // handlesData[5],
    // handlesData[6],
    // handlesData[7],
    // handlesData[8],
    // handlesData[9],
    // handlesData[10],
  ],
  'Kriegoff K80': [
    handlesData[0],
    handlesData[2],
    // handlesData[4],
    // handlesData[5],
  ],
  'Rizzini BR 440, BR 460 (Removable Trigger)': [
    handlesData[0],
    handlesData[2],
    // handlesData[4],
    // handlesData[5],
  ],
  'Rizzini Vertex, BR110 (No Removable Trigger)': [
    handlesData[0],
    handlesData[2],
    // handlesData[4],
    // handlesData[5],
  ],
  'A. Zoli Kronos: Z Gun': [
    handlesData[0],
    handlesData[2],
    // handlesData[4],
    // handlesData[5],
  ],
  'Beretta A400': [handlesData[11]],
};

// Grip size by model
export const gripSizeByHandle: Record<string, string[]> = {
  BLANK: [gripSizeData[0], gripSizeData[8], gripSizeData[4]],
  'BLANK SS': [gripSizeData[0], gripSizeData[8], gripSizeData[4]],
  'STD HANDLE - GLOVE': [
    gripSizeData[0],
    gripSizeData[1],
    gripSizeData[2],
    gripSizeData[3],
    gripSizeData[4],
  ],
  'C-HANDLE - NO GLOVE': [gripSizeData[6]],
  'SPD HANDLE - HALF GLOVE': [
    gripSizeData[1],
    gripSizeData[2],
    gripSizeData[3],
    gripSizeData[4],
  ],
  'ANATOMIC GRIP': [gripSizeData[7]],
  'LAMINATE HANDLE BLACK': [
    gripSizeData[0],
    gripSizeData[1],
    gripSizeData[2],
    gripSizeData[3],
    gripSizeData[4],
  ],
  'LAMINATE HANDLE BLUE': [
    gripSizeData[0],
    gripSizeData[1],
    gripSizeData[2],
    gripSizeData[3],
    gripSizeData[4],
  ],
  'LAMINATE HANDLE HAVANA': [
    gripSizeData[0],
    gripSizeData[1],
    gripSizeData[2],
    gripSizeData[3],
    gripSizeData[4],
  ],
  'LAMINATE HANDLE ORANGE': [
    gripSizeData[0],
    gripSizeData[1],
    gripSizeData[2],
    gripSizeData[3],
    gripSizeData[4],
  ],
  'LAMINATE HANDLE RED': [
    gripSizeData[0],
    gripSizeData[1],
    gripSizeData[2],
    gripSizeData[3],
    gripSizeData[4],
  ],
  'A400 HANDLE': [gripSizeData[9], gripSizeData[10]],
};

// Hanldes by model
export const handlesByModel: Record<string, string[]> = {
  std: [
    handlesData[0],
    handlesData[2],
    handlesData[3],
    // handlesData[4],
    // handlesData[5],
    // handlesData[6],
    // handlesData[7],
    // handlesData[8],
    // handlesData[9],
    // handlesData[10],
    handlesData[11],
  ],
  junior: [
    handlesData[0],
    handlesData[2],
    handlesData[3],
    // handlesData[4],
    // handlesData[5],
    // handlesData[6],
    // handlesData[7],
    // handlesData[8],
    // handlesData[9],
    // handlesData[10],
    handlesData[11],
  ],
  rinascimento: [
    handlesData[0],
    handlesData[2],
    handlesData[3],
    // handlesData[4],
    //  handlesData[5],
    // handlesData[6],
    // handlesData[7],
    // handlesData[8],
    // handlesData[9],
    // handlesData[10],
    handlesData[11],
  ],
  rr: [
    handlesData[0],
    handlesData[2],
    handlesData[3],
    // handlesData[4],
    // handlesData[5],
    // handlesData[6],
    // handlesData[7],
    // handlesData[8],
    // handlesData[9],
    // handlesData[10],
    handlesData[11],
  ],
  'rr-junior': [
    handlesData[0],
    handlesData[2],
    handlesData[3],
    // handlesData[4],
    // handlesData[5],
    // handlesData[6],
    // handlesData[7],
    // handlesData[8],
    // handlesData[9],
    // handlesData[10],
    handlesData[11],
  ],
  'rr-rinascimento': [
    handlesData[0],
    handlesData[2],
    handlesData[3],
    // handlesData[4],
    // handlesData[5],
    // handlesData[6],
    // handlesData[7],
    // handlesData[8],
    // handlesData[9],
    // handlesData[10],
    handlesData[11],
  ],
  superleggero: [
    handlesData[0],
    handlesData[2],
    handlesData[3],
    // handlesData[4],
    //  handlesData[5],
    // handlesData[6],
    // handlesData[7],
    // handlesData[8],
    // handlesData[9],
    // handlesData[10],
    handlesData[11],
  ],
  spd: [handlesData[0], handlesData[3], handlesData[4], handlesData[11]], // handlesData[5]],
  supersport: [handlesData[1]], // handlesData[5]],
  'c-model': [handlesData[3]],
};

// Pipes by model
/*
export const pipesByModel: Record<string, string[]> = {
  std: [pipeSizeData[1], pipeSizeData[2], pipeSizeData[3]],
  junior: [pipeSizeData[0]],
  rinascimento: [pipeSizeData[1], pipeSizeData[2], pipeSizeData[3]],
  rr: [pipeSizeData[1], pipeSizeData[2], pipeSizeData[3]],
  'rr-junior': [pipeSizeData[0]],
  'rr-rinascimento': [pipeSizeData[1], pipeSizeData[2], pipeSizeData[3]],
  superleggero: [pipeSizeData[1], pipeSizeData[2], pipeSizeData[3]],
  spd: [pipeSizeData[1], pipeSizeData[2], pipeSizeData[3]],
  supersport: [pipeSizeData[1], pipeSizeData[2], pipeSizeData[3]],
  'c-model': [pipeSizeData[1], pipeSizeData[2], pipeSizeData[3]],
};*/

// Sport by model
export const sportByModel: Record<string, string[]> = {
  std: [sportData[0], sportData[1], sportData[2], sportData[3]],
  junior: [sportData[0], sportData[1], sportData[2], sportData[3]],
  rinascimento: [sportData[0], sportData[1], sportData[2], sportData[3]],
  rr: [sportData[0], sportData[1], sportData[2]],
  'rr-junior': [sportData[0], sportData[1], sportData[2]],
  'rr-rinascimento': [sportData[0], sportData[1], sportData[2]],
  superleggero: [sportData[0], sportData[1], sportData[2], sportData[3]],
  spd: [sportData[1], sportData[2]],
  supersport: [sportData[0], sportData[1], sportData[2]],
  'c-model': [sportData[0], sportData[1], sportData[2]],
};

// Pipe by pipeSize
/*
export const pipesByPipeSize: Record<string, string[]> = {
  [pipeSizeData[0]]: [
    '120R',
    '120OR',
    '120G',
    '120S',
    '120BU',
    '120B',
    'RR120R',
    '120OR',
    '120G',
    '120S',
    '120BU',
    '120B',
  ],
  [pipeSizeData[1]]: [
    '140R',
    '140OR',
    '140G',
    '140S',
    '140BU',
    '140B',
    '140SLB',
    '140SLBU',
    '140SLR',
    '140SLOR',
    '140SLS',
    '140SLG',
    'C-140R',
    'C-140OR',
    'C-140G',
    'C-140S',
    'C-140B',
    'SS-140 TM',
    'RR140R',
    '140OR',
    '140G',
    '140S',
    '140BU',
    '140B',
    'SPD140T',
    'SPD140BU',
  ],
  [pipeSizeData[2]]: [
    '160R',
    '160OR',
    '160G',
    '160S',
    '160BU',
    '160B',
    '160SLB',
    '160SLBU',
    '160SLR',
    '160SLOR',
    '160SLS',
    '160SLG',
    'C-160R',
    'C-160OR',
    'C-160G',
    'C-160S',
    'C-160B',
    'SS-160 TM',
    'RR160R',
    '160OR',
    '160G',
    '160S',
    '160BU',
    '160B',
    'SPD160T',
    'SPD160BU',
  ],
  [pipeSizeData[3]]: [
    '180R',
    '180OR',
    '180G',
    '180S',
    '180BU',
    '180B',
    '180SLB',
    '180SLBU',
    '180SLR',
    '180SLOR',
    '180SLS',
    '180SLG',
    'C-180R',
    'C-180OR',
    'C-180G',
    'C-180S',
    'C-180B',
    'SS-180 TM',
    'RR180R',
    '180OR',
    '180G',
    '180S',
    '180BU',
    '180B',
    'SPD180T',
    'SPD180BU',
  ],
};*/

// Pipe by pipeSize
export const getPipeCodesByMM = (pipeSizeString: string) => {
  const mmMatch = pipeSizeString.match(/(\d+)\s*mm/);
  if (!mmMatch) return [];

  let mm = mmMatch[1];

  if (mm === '130') {
    mm = '120';
  }

  const pipeCodesByMM = {
    '120': [
      '120R',
      '120OR',
      '120G',
      '120S',
      '120BU',
      '120B',
      'RR120R',
      '120OR',
      '120G',
      '120S',
      '120BU',
      '120B',
    ],
    '140': [
      '140R',
      '140OR',
      '140G',
      '140S',
      '140BU',
      '140B',
      '140SLB',
      '140SLBU',
      '140SLR',
      '140SLOR',
      '140SLS',
      '140SLG',
      'C-140R',
      'C-140OR',
      'C-140G',
      'C-140S',
      'C-140B',
      'SS-140 TM',
      'RR140R',
      'SPD140T',
      'SPD140BU',
    ],
    '160': [
      '160R',
      '160OR',
      '160G',
      '160S',
      '160BU',
      '160B',
      '160SLB',
      '160SLBU',
      '160SLR',
      '160SLOR',
      '160SLS',
      '160SLG',
      'C-160R',
      'C-160OR',
      'C-160G',
      'C-160S',
      'C-160B',
      'SS-160 TM',
      'RR160R',
      'SPD160T',
      'SPD160BU',
    ],
    '180': [
      '180R',
      '180OR',
      '180G',
      '180S',
      '180BU',
      '180B',
      '180SLB',
      '180SLBU',
      '180SLR',
      '180SLOR',
      '160SLS',
      '180SLG',
      'C-180R',
      'C-180OR',
      'C-180G',
      'C-180S',
      'C-180B',
      'SS-180 TM',
      'RR180R',
      'SPD180T',
      'SPD180BU',
    ],
  };

  return pipeCodesByMM[mm as keyof typeof pipeCodesByMM] || [];
};

// Plates by sport
export const platesBySport: Record<string, string[]> = {
  [sportData[0]]: [
    'PTB',
    'PTOR',
    'PTR',
    'PTS',
    'PTG',
    'PTLHB',
    'PTRHB',
    'PT RRB',
    'PT RROR',
    'PT RRR',
    'PT RRS',
    'PT RRG',
    'PT RRLH',
    'PT RRRH',
    'PT SSB',
    'C-PT B',
  ],
  [sportData[1]]: [
    'PSB',
    'PSOR',
    'PSR',
    'PSA',
    'PSG',
    'PSLHB',
    'PSRHB',
    'PS RRB',
    'PS RROR',
    'PS RRR',
    'PS RRS',
    'PS RRG',
    'PS SSB',
    'C-PS B',
    'PS SPDB',
  ],
  [sportData[2]]: [
    'PSB',
    'PSOR',
    'PSR',
    'PSA',
    'PSG',
    'PSLHB',
    'PSRHB',
    'PS RRB',
    'PS RROR',
    'PS RRR',
    'PS RRS',
    'PS RRG',
    'PS SSB',
    'C-PS B',
    'PS SPDB',
  ],
  [sportData[3]]: ['PDTB'],
};

// Custom category name
export const customCategoryNames: Record<string, string[]> = {
  COMBS: ['NOCE', 'NOCE & GOMMA', 'LAMINATO', 'CARBONIO'],
  'BUTT PLATES': ['GOMMATI', 'LEGNO', 'LAMINATO', 'SHU'],
  'Rosetta/Spheres': ['STD', 'JPN'],
};

// Map with attribute codes for each category COMBS
export const combsAttributesByCustomCategory: Record<string, string[]> = {
  LAMINATO: [
    'WLAM24BU',
    'WLAM32BU',
    'WLAM24B',
    'WLAM32B',
    'WLAM24HA',
    'WLAM32HA',
    'WLAM24R',
    'WLAM32R',
    'WLAM24OR',
    'WLAM32OR',
    'WLAM24BU L',
    'WLAM32BU L',
    'WLAM24B L',
    'WLAM32B L',
    'WLAM24HA L',
    'WLAM32HA L',
    'WLAM24R L',
    'WLAM32R L',
    'WLAM24OR L',
    'WLAM32OR L',
    'WRLAM24BU',
    'WRLAM32BU',
    'WRLAM24B',
    'WRLAM32B',
    'WRLAM24HA',
    'WRLAM32HA',
    'WRLAM24R',
    'WRLAM32R',
    'WRLAM24OR',
    'WRLAM32OR',
  ],
  CARBONIO: ['CF24', 'CF32'],
  NOCE: [
    'W24 L',
    'W32 L',
    'W24',
    'W32',
    'W40',
    'W50',
    'WJR24',
    'WJR32',
    'WRRJR24',
    'WRRJR32',
    'WSPD24',
    'WSPD32',
  ],
  'NOCE & GOMMA': ['WR24', 'WR32', 'WR24 L', 'WR32 L', 'WR40', 'WR50'],
};

// Map with attribute codes for each category BUTT PLATES
export const buttPlatesAttributesByCustomCategory: Record<string, string[]> = {
  LEGNO: ['W12', 'W12L'],
  LAMINATO: ['W12BL', 'W12BU', 'W12HA', 'W12OR', 'W12R'],
  SHU: ['SH15BU', 'SH15OR', 'SH15R', 'SH15B'],
  GOMMATI: ['C15', 'CS15', 'C23', 'C32'],
};

// Map with attribute codes for each category BUTT PLATES
export const rosettaSpheresAttributesByCustomCategory: Record<
  string,
  string[]
> = {
  JPN: [
    'RSTJPN',
    'RSTSL',
    'SPHJPNB',
    'SPHJPNG',
    'SPHJPNOR',
    'SPHJPNR',
    'SPHJPNS',
  ],
  STD: ['RST', 'RST SS', 'SPHB', 'SPHG', 'SPHOR', 'SPHR', 'SPHS'],
};

//   STD: ['RST', 'RSTCF', 'RST SS', 'SPHB', 'SPHG', 'SPHOR', 'SPHR', 'SPHS'], // Ho rimosso la rosetta carbon fiber pipe: 'RSTCF'

// Mapping dei tubi per modello e taglia impugnatura
export const pipesByModelAndGripSize: Record<
  string,
  Record<string, string[]>
> = {
  // STD, RINASCIMENTO, SUPERLEGGERO, SPD, SUPERSPORT
  std: {
    XS: [
      'SHORT - 140 mm - Length range from 34,7 to 37,2 cm',
      'MEDIUM - 160 mm - Length range from 36,7 to 39,2 cm',
      'LONG - 180 mm - Length range from 38,7 to 41,2 cm',
    ],
    'S, M, L': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    S: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    M: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    L: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    XL: [
      'SHORT - 140 mm - Length range from 36,3 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38,3 to 40,8 cm',
      'LONG - 180 mm - Length range from 40,3 to 42,8 cm',
    ],
    I: [
      'SHORT - 140 mm - Length range from 35 to 37,5 cm',
      'MEDIUM - 160 mm - Length range from 37 to 39,5 cm',
      'LONG - 180 mm - Length range from 39 to 41,5 cm',
    ],
    II: [
      'SHORT - 140 mm - Length range from 37 to 39,5 cm',
      'MEDIUM - 160 mm - Length range from 39 to 41,5 cm',
      'LONG - 180 mm - Length range from 41 to 43,5 cm',
    ],
    'Taglia unica': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
  },
  rinascimento: {
    XS: [
      'SHORT - 140 mm - Length range from 34,7 to 37,2 cm',
      'MEDIUM - 160 mm - Length range from 36,7 to 39,2 cm',
      'LONG - 180 mm - Length range from 38,7 to 41,2 cm',
    ],
    'S, M, L': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    S: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    M: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    L: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    XL: [
      'SHORT - 140 mm - Length range from 36,3 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38,3 to 40,8 cm',
      'LONG - 180 mm - Length range from 40,3 to 42,8 cm',
    ],
    I: [
      'SHORT - 140 mm - Length range from 35 to 37,5 cm',
      'MEDIUM - 160 mm - Length range from 37 to 39,5 cm',
      'LONG - 180 mm - Length range from 39 to 41,5 cm',
    ],
    II: [
      'SHORT - 140 mm - Length range from 37 to 39,5 cm',
      'MEDIUM - 160 mm - Length range from 39 to 41,5 cm',
      'LONG - 180 mm - Length range from 41 to 43,5 cm',
    ],
    'Taglia unica': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
  },
  superleggero: {
    XS: [
      'SHORT - 140 mm - Length range from 34,7 to 37,2 cm',
      'MEDIUM - 160 mm - Length range from 36,7 to 39,2 cm',
      'LONG - 180 mm - Length range from 38,7 to 41,2 cm',
    ],
    'S, M, L': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    S: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    M: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    L: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    XL: [
      'SHORT - 140 mm - Length range from 36,3 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38,3 to 40,8 cm',
      'LONG - 180 mm - Length range from 40,3 to 42,8 cm',
    ],
    I: [
      'SHORT - 140 mm - Length range from 35 to 37,5 cm',
      'MEDIUM - 160 mm - Length range from 37 to 39,5 cm',
      'LONG - 180 mm - Length range from 39 to 41,5 cm',
    ],
    II: [
      'SHORT - 140 mm - Length range from 37 to 39,5 cm',
      'MEDIUM - 160 mm - Length range from 39 to 41,5 cm',
      'LONG - 180 mm - Length range from 41 to 43,5 cm',
    ],
    'Taglia unica': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
  },
  spd: {
    XS: [
      'SHORT - 140 mm - Length range from 34,7 to 37,2 cm',
      'MEDIUM - 160 mm - Length range from 36,7 to 39,2 cm',
      'LONG - 180 mm - Length range from 38,7 to 41,2 cm',
    ],
    'S, M, L': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    S: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    M: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    L: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    XL: [
      'SHORT - 140 mm - Length range from 36,3 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38,3 to 40,8 cm',
      'LONG - 180 mm - Length range from 40,3 to 42,8 cm',
    ],
    I: [
      'SHORT - 140 mm - Length range from 35 to 37,5 cm',
      'MEDIUM - 160 mm - Length range from 37 to 39,5 cm',
      'LONG - 180 mm - Length range from 39 to 41,5 cm',
    ],
    II: [
      'SHORT - 140 mm - Length range from 37 to 39,5 cm',
      'MEDIUM - 160 mm - Length range from 39 to 41,5 cm',
      'LONG - 180 mm - Length range from 41 to 43,5 cm',
    ],
    'Taglia unica': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
  },
  supersport: {
    XS: [
      'SHORT - 140 mm - Length range from 34,7 to 37,2 cm',
      'MEDIUM - 160 mm - Length range from 36,7 to 39,2 cm',
      'LONG - 180 mm - Length range from 38,7 to 41,2 cm',
    ],
    'S, M, L': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    S: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    M: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    L: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    XL: [
      'SHORT - 140 mm - Length range from 36,3 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38,3 to 40,8 cm',
      'LONG - 180 mm - Length range from 40,3 to 42,8 cm',
    ],
    I: [
      'SHORT - 140 mm - Length range from 35 to 37,5 cm',
      'MEDIUM - 160 mm - Length range from 37 to 39,5 cm',
      'LONG - 180 mm - Length range from 39 to 41,5 cm',
    ],
    II: [
      'SHORT - 140 mm - Length range from 37 to 39,5 cm',
      'MEDIUM - 160 mm - Length range from 39 to 41,5 cm',
      'LONG - 180 mm - Length range from 41 to 43,5 cm',
    ],
    'Taglia unica': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
  },
  // JUNIOR - Solo 120mm
  junior: {
    XS: ['SUPER SHORT - 120 mm - Length range from 33,2 to 35,2 cm'],
    'S, M, L': ['SUPER SHORT - 120 mm - Length range from 34 to 36 cm'],
    S: ['SUPER SHORT - 120 mm - Length range from 34 to 36 cm'],
    M: ['SUPER SHORT - 120 mm - Length range from 34 to 36 cm'],
    L: ['SUPER SHORT - 120 mm - Length range from 34 to 36 cm'],
    XL: ['SUPER SHORT - 120 mm - Length range from 34,8 to 36,8 cm'],
    I: ['SUPER SHORT - 120 mm - Length range from 34 to 36,5 cm'],
    II: ['SUPER SHORT - 120 mm - Length range from 36 to 38,5 cm'],
    'Taglia unica': ['SUPER SHORT - 120 mm - Length range from 34 to 36 cm'],
  },
  // RR JUNIOR - Solo 130mm
  'rr-junior': {
    XS: ['SUPER SHORT - 130 mm - Length range from 34,4 to 36,2 cm'],
    'S, M, L': ['SUPER SHORT - 130 mm - Length range from 35,2 to 37 cm'],
    S: ['SUPER SHORT - 130 mm - Length range from 35,2 to 37 cm'],
    M: ['SUPER SHORT - 130 mm - Length range from 35,2 to 37 cm'],
    L: ['SUPER SHORT - 130 mm - Length range from 35,2 to 37 cm'],
    XL: ['SUPER SHORT - 130 mm - Length range from 36 to 37,8 cm'],
    I: ['SUPER SHORT - 130 mm - Length range from 34 to 36 cm'],
    II: ['SUPER SHORT - 130 mm - Length range from 36 to 38 cm'],
    'Taglia unica': ['SUPER SHORT - 130 mm - Length range from 34 to 36 cm'],
  },
  'rr-rinascimento': {
    XS: [
      'SHORT - 140 mm - Length range from 35,2 to 37,2 cm',
      'MEDIUM - 160 mm - Length range from 37,2 to 39,2 cm',
      'LONG - 180 mm - Length range from 39,2 to 41,2 cm',
    ],
    'S, M, L': [
      'SHORT - 140 mm - Length range from 36 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38 to 40 cm',
      'LONG - 180 mm - Length range from 40 to 42 cm',
    ],
    S: [
      'SHORT - 140 mm - Length range from 36 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38 to 40 cm',
      'LONG - 180 mm - Length range from 40 to 42 cm',
    ],
    M: [
      'SHORT - 140 mm - Length range from 36 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38 to 40 cm',
      'LONG - 180 mm - Length range from 40 to 42 cm',
    ],
    L: [
      'SHORT - 140 mm - Length range from 36 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38 to 40 cm',
      'LONG - 180 mm - Length range from 40 to 42 cm',
    ],
    XL: [
      'SHORT - 140 mm - Length range from 36,8 to 38,8 cm',
      'MEDIUM - 160 mm - Length range from 38,8 to 40,8 cm',
      'LONG - 180 mm - Length range from 40,8 to 42,8 cm',
    ],
    I: [
      'SHORT - 140 mm - Length range from 35 to 37 cm',
      'MEDIUM - 160 mm - Length range from 37 to 39 cm',
      'LONG - 180 mm - Length range from 39 to 41 cm',
    ],
    II: [
      'SHORT - 140 mm - Length range from 37 to 39 cm',
      'MEDIUM - 160 mm - Length range from 39 to 41 cm',
      'LONG - 180 mm - Length range from 41 to 43 cm',
    ],
    'Taglia unica': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
  },
  rr: {
    XS: [
      'SHORT - 140 mm - Length range from 35,2 to 37,2 cm',
      'MEDIUM - 160 mm - Length range from 37,2 to 39,2 cm',
      'LONG - 180 mm - Length range from 39,2 to 41,2 cm',
    ],
    'S, M, L': [
      'SHORT - 140 mm - Length range from 36 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38 to 40 cm',
      'LONG - 180 mm - Length range from 40 to 42 cm',
    ],
    S: [
      'SHORT - 140 mm - Length range from 36 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38 to 40 cm',
      'LONG - 180 mm - Length range from 40 to 42 cm',
    ],
    M: [
      'SHORT - 140 mm - Length range from 36 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38 to 40 cm',
      'LONG - 180 mm - Length range from 40 to 42 cm',
    ],
    L: [
      'SHORT - 140 mm - Length range from 36 to 38 cm',
      'MEDIUM - 160 mm - Length range from 38 to 40 cm',
      'LONG - 180 mm - Length range from 40 to 42 cm',
    ],
    XL: [
      'SHORT - 140 mm - Length range from 36,8 to 38,8 cm',
      'MEDIUM - 160 mm - Length range from 38,8 to 40,8 cm',
      'LONG - 180 mm - Length range from 40,8 to 42,8 cm',
    ],
    I: [
      'SHORT - 140 mm - Length range from 35 to 37 cm',
      'MEDIUM - 160 mm - Length range from 37 to 39 cm',
      'LONG - 180 mm - Length range from 39 to 41 cm',
    ],
    II: [
      'SHORT - 140 mm - Length range from 37 to 39 cm',
      'MEDIUM - 160 mm - Length range from 39 to 41 cm',
      'LONG - 180 mm - Length range from 41 to 43 cm',
    ],
    'Taglia unica': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
  },
  // C MODEL - Solo S, M, L (XS e XL mostrano "-" = non disponibili)
  'c-model': {
    'S, M, L': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    S: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    M: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    L: [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
    I: [
      'SHORT - 140 mm - Length range from 35 to 37,5 cm',
      'MEDIUM - 160 mm - Length range from 37 to 39,5 cm',
      'LONG - 180 mm - Length range from 39 to 41,5 cm',
    ],
    II: [
      'SHORT - 140 mm - Length range from 37 to 39,5 cm',
      'MEDIUM - 160 mm - Length range from 39 to 41,5 cm',
      'LONG - 180 mm - Length range from 41 to 43,5 cm',
    ],
    'Taglia unica': [
      'SHORT - 140 mm - Length range from 35,5 to 38 cm',
      'MEDIUM - 160 mm - Length range from 37,5 to 40 cm',
      'LONG - 180 mm - Length range from 39,5 to 42 cm',
    ],
  },
};
